import isString from "lodash/isString";
import { KanbanCard } from "../../../model/kanban/KanbanCard";
import { appActions } from "../../../redux/app/app.slice";
import { kanbanActions } from "../../../redux/kanban/kanban.slice";
import { AppDispatch } from "../../../redux/store";
import { AtiraToast } from "../../../utils/AtiraToast";
import { taskActions } from "../../../redux/task/task.slice";
import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";
import { GetTasksFilterDto } from "../../../model/task/dto/GetTasksFilterDto";
import { UseFormGetValues } from "react-hook-form";

type Props = {
  pathname: string;
  userId: string;
  tasksPage: number;
  tasksPageSize: number;
  searchKeyword?: string;
  dispatch: AppDispatch;
  setKanbanCard: ATVoidFunction<KanbanCard>;
  contextGetValues: UseFormGetValues<GetTasksFilterDto>;
  kanbanCardId?: string;
};

export default function fetchAfterKanbanCardAction({
  pathname,
  userId,
  tasksPage,
  tasksPageSize,
  dispatch,
  contextGetValues,
  setKanbanCard,
  kanbanCardId,
  searchKeyword,
}: Props) {
  const fetchOnKanbanPage = async () => {
    try {
      if (!kanbanCardId) {
        return;
      }

      const kanbanCard = await dispatch(
        kanbanActions.getKanbanCardById({ userId, cardId: kanbanCardId }),
      ).unwrap();

      setKanbanCard(kanbanCard);
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    }
  };

  const fetchOnSearchPage = async () => {
    try {
      if (!kanbanCardId) {
        return;
      }

      const { results } = await dispatch(
        appActions.search({
          userId,
          keyword: searchKeyword!,
        }),
      ).unwrap();

      const updatedKanbanCard = results?.find(
        (entity) => entity._kind === "deal" && entity._id === kanbanCardId,
      );

      if (updatedKanbanCard) {
        setKanbanCard(updatedKanbanCard as KanbanCard);
      }
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    }
  };

  const fetchOnTasksPage = async () => {
    try {
      if (!kanbanCardId) {
        return;
      }

      const { data } = await dispatch(
        taskActions.getAllTasks({
          userId,
          meta: {
            page: tasksPage - 1,
            count: tasksPageSize,
          },
          ...omitBy(
            {
              keyword: contextGetValues("keyword"),
              kind: contextGetValues("kind"),
              reminder: contextGetValues("reminder"),
              done: contextGetValues("done"),
              range: contextGetValues("range"),
              scope: contextGetValues("scope"),
            },
            isNil,
          ),
        }),
      ).unwrap();

      const updatedKanbanCard = data?.find(
        (t) => t.parentId === kanbanCardId,
      )?.parent;

      if (updatedKanbanCard) {
        setKanbanCard(updatedKanbanCard as KanbanCard);
      }
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    }
  };

  switch (true) {
    case pathname.includes("/deals"):
      return fetchOnKanbanPage();
    case pathname.includes("/search") && isString(searchKeyword):
      return fetchOnSearchPage();
    case pathname.includes("/tasks"):
      return fetchOnTasksPage();
  }
}
